<template>
  <div class="container-fluid py-4 px-3 px-md-4">
    <div class="breadcrumb text-md px-0 mb-4">
      <p>
        <span class="breadcrumb-item" @click="$router.push('/dashboard')">Inicio</span>
        &rsaquo; Informes
      </p>
    </div>

    <!-- Filtros -->
    <div class="card ficha-listado mb-4">
      <div class="card-body px-3 px-md-4 pt-3 pb-3">
        <h6 class="mb-3 fw-semibold">Selecciona tipster y periodo</h6>

        <!-- Tipster -->
        <div class="row g-3 align-items-end mb-3">
          <div class="col-12 col-sm-8 col-md-5 col-lg-4">
            <label class="form-label form-label-sm">Tipster</label>
            <select
              v-model="tipsterSeleccionado"
              class="form-select form-select-sm q-select"
              :disabled="cargandoTipsters"
            >
              <option value="" disabled>Selecciona tipster…</option>
              <option v-for="t in tipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
            </select>
          </div>
        </div>

        <!-- Botones de periodo -->
        <div class="periodo-btns mb-2">
          <button
            v-for="p in periodos"
            :key="p.value"
            :class="['btn-periodo', { active: periodo === p.value }]"
            :disabled="!tipsterSeleccionado"
            @click="seleccionarPeriodo(p.value)"
          >
            <i v-if="p.value === 'custom'" class="fas fa-calendar-alt me-1"></i>
            {{ p.label }}
          </button>
        </div>

        <!-- Fechas personalizadas -->
        <div v-if="periodo === 'custom'" class="custom-dates mt-2 mb-1">
          <input
            type="date"
            v-model="fechaDesde"
            class="form-control form-control-sm q-input date-input"
            :max="fechaHasta || undefined"
          />
          <span class="sep-dash">—</span>
          <input
            type="date"
            v-model="fechaHasta"
            class="form-control form-control-sm q-input date-input"
            :min="fechaDesde || undefined"
          />
        </div>
      </div>
    </div>

    <!-- Botones de informes -->
    <div class="inf-hub-grid">
      <button
        class="inf-hub-card"
        :disabled="!puedeNavegar"
        @click="irA('MetricasNegocio')"
      >
        <i class="fa fa-chart-line inf-hub-icon"></i>
        <span class="inf-hub-title">Métricas de negocio</span>
        <span class="inf-hub-desc">KPIs, MRR, LTV, churn y más</span>
      </button>

      <button
        class="inf-hub-card"
        :disabled="!puedeNavegar"
        @click="irA('Comisiones')"
      >
        <i class="fa fa-percent inf-hub-icon"></i>
        <span class="inf-hub-title">Comisiones</span>
        <span class="inf-hub-desc">Comisiones por tipster y periodo</span>
      </button>

      <button
        class="inf-hub-card"
        :disabled="!puedeNavegar"
        @click="irA('InformePedidos')"
      >
        <i class="fa fa-chart-bar inf-hub-icon"></i>
        <span class="inf-hub-title">Informe de Suscripciones</span>
        <span class="inf-hub-desc">Funnel de conversión y estado de suscripciones</span>
      </button>

      <button
        class="inf-hub-card"
        :disabled="!puedeNavegar"
        @click="irA('InformeVentas')"
      >
        <i class="fa fa-euro-sign inf-hub-icon"></i>
        <span class="inf-hub-title">Ventas Totales</span>
        <span class="inf-hub-desc">Listado completo de ingresos con exportación PDF y Excel</span>
      </button>
    </div>

    <p v-if="!tipsterSeleccionado || !periodo" class="text-muted text-center mt-4" style="font-size:13px">
      <span v-if="!tipsterSeleccionado">Selecciona un tipster</span>
      <span v-else-if="!periodo"> y un periodo</span>
      para activar los informes
    </p>
  </div>
</template>

<script>
export default {
  name: "Informes",
  data() {
    return {
      tipsterSeleccionado: "",
      tipsters: [],
      cargandoTipsters: false,
      periodo: "",
      fechaDesde: "",
      fechaHasta: "",
      periodos: [
        { value: "hoy",    label: "Hoy" },
        { value: "mes",    label: "Mes actual" },
        { value: "3",      label: "3 meses" },
        { value: "6",      label: "6 meses" },
        { value: "12",     label: "12 meses" },
        { value: "all",    label: "Todo" },
        { value: "custom", label: "Personalizar" },
      ],
    };
  },
  computed: {
    dateRange() {
      const hoy = new Date();
      const fmt = (d) => d.toISOString().slice(0, 10);
      if (!this.periodo || this.periodo === "all") return { desde: null, hasta: null };
      if (this.periodo === "hoy") return { desde: fmt(hoy), hasta: fmt(hoy) };
      if (this.periodo === "mes") {
        return { desde: fmt(new Date(hoy.getFullYear(), hoy.getMonth(), 1)), hasta: fmt(hoy) };
      }
      if (this.periodo === "custom") {
        return { desde: this.fechaDesde || null, hasta: this.fechaHasta || null };
      }
      const meses = parseInt(this.periodo);
      const desde = new Date(hoy);
      desde.setMonth(desde.getMonth() - meses);
      return { desde: fmt(desde), hasta: fmt(hoy) };
    },
    puedeNavegar() {
      if (!this.tipsterSeleccionado || !this.periodo) return false;
      if (this.periodo === "custom" && (!this.fechaDesde || !this.fechaHasta)) return false;
      return true;
    },
  },
  async mounted() {
    this.cargandoTipsters = true;
    try {
      const resp = await this.$store.dispatch("auth/listaTipsters");
      this.tipsters = Array.isArray(resp) ? resp : [];
    } catch { /* silencioso */ } finally {
      this.cargandoTipsters = false;
    }
  },
  methods: {
    seleccionarPeriodo(p) {
      this.periodo = p;
    },
    irA(routeName) {
      const q = { tipster_id: this.tipsterSeleccionado, periodo: this.periodo };
      if (this.dateRange.desde) q.desde = this.dateRange.desde;
      if (this.dateRange.hasta) q.hasta = this.dateRange.hasta;
      this.$router.push({ name: routeName, query: q });
    },
  },
};
</script>

<style scoped>
.periodo-btns { display: flex; gap: 6px; flex-wrap: wrap; }
.btn-periodo {
  padding: 4px 14px;
  border: 1.5px solid var(--q-border);
  background: transparent;
  border-radius: 20px;
  font-size: 13px;
  color: var(--q-text);
  cursor: pointer;
  transition: all 0.15s;
}
.btn-periodo:disabled { opacity: 0.4; cursor: not-allowed; }
.btn-periodo:hover:not(:disabled) { border-color: var(--q-gold); color: var(--q-gold); }
.btn-periodo.active { background: var(--q-gold); border-color: var(--q-gold); color: #000; font-weight: 600; }

.custom-dates { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.date-input { max-width: 150px; }
.sep-dash { color: var(--q-text-muted, #888); }

.inf-hub-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
  max-width: 800px;
}
.inf-hub-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 1.25rem 1.5rem;
  background: var(--q-card);
  border: 1.5px solid var(--q-border);
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
  text-align: left;
}
.inf-hub-card:hover:not(:disabled) {
  border-color: var(--q-gold);
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  transform: translateY(-2px);
}
.inf-hub-card:disabled { opacity: 0.4; cursor: not-allowed; transform: none; }
.inf-hub-icon { font-size: 1.4rem; color: var(--q-gold); }
.inf-hub-title { font-size: 0.95rem; font-weight: 600; color: var(--q-text); }
.inf-hub-desc { font-size: 0.78rem; color: var(--q-text-muted, #888); }

@media (max-width: 600px) {
  .inf-hub-grid { grid-template-columns: 1fr; }
}
</style>
